import { ButtonColor } from "@/common/enum/button-color";
import { PartnerNotificationPath } from "@/common/enum/path";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { NoticeDetailDto } from "@/types/dto/notice-detail-dto";
import { Button } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { AngleLeftOutlineIcon } from "../icon/AngleLeftlineIcon";
import { AngleRightOutlineIcon } from "../icon/AngleRightlineIcon";
import { Footnote12Description } from "../typography/Footnote12Description";

interface Props {
  noticePage: BasePageDto<NoticeDetailDto>;
  goToPage: (pageNumber: number) => void;
}

export const PartnerNoticeHeaderButtonGroup: React.FC<Props> = ({
  noticePage,
  goToPage,
}) => {
  const navigate = useNavigate();
  const currentPage = noticePage.currentPage;
  const totalPage = noticePage.totalPage;

  const handleAllPageButtonClick = () => {
    navigate(PartnerNotificationPath.NOTICE);
  };

  const handlePrevPage = () => {
    goToPage(currentPage - 1);
  };

  const handleNextPage = () => {
    goToPage(currentPage + 1);
  };

  return (
    <Button.Group>
      <Button
        size="sx"
        color={currentPage === 1 ? "" : ButtonColor.ORIGIN_GRAY}
        onClick={handlePrevPage}
        disabled={currentPage === 1}
      >
        <div className="flex items-center mx-[4px]">
          <AngleLeftOutlineIcon
            size={20}
            color={
              currentPage === 1
                ? "text-primary-gray"
                : "text-semantic-text-secondary"
            }
          />
        </div>
      </Button>
      <Button
        size="sx"
        color={ButtonColor.ORIGIN_GRAY}
        onClick={handleAllPageButtonClick}
      >
        <div className="flex items-center justify-center mt-[4px] mb-[2px] mx-[12px]">
          <Footnote12Description>전체보기</Footnote12Description>
        </div>
      </Button>
      <Button
        size="sx"
        color={currentPage + 1 > totalPage ? "" : ButtonColor.ORIGIN_GRAY}
        onClick={handleNextPage}
        disabled={currentPage + 1 > totalPage}
      >
        <div className="flex items-center mx-[4px]">
          <AngleRightOutlineIcon
            size={20}
            color={
              currentPage + 1 > totalPage
                ? "text-primary-gray"
                : "text-semantic-text-secondary"
            }
          />
        </div>
      </Button>
    </Button.Group>
  );
};
